export default __webpack_public_path__ + "static/media/entenda_sm.dfd0a779.webp";